










































import Vue from "vue";
export default Vue.extend({
  props: {
    multiple: Boolean,
    value: [Array as () => File[], File, Object],
  },
  data(): any {
    return {
      files: [] as File[],
      dragover: false as boolean,
      empty: true as boolean,
    };
  },
  methods: {
    onDrop(event: any) {
      event.preventDefault();
      this.addFiles(event.dataTransfer.files);
    },
    enableDragover() {
      this.dragover = true;
    },
    disableDragover() {
      this.dragover = false;
    },
    onFileChange(e: any) {
      this.addFiles(e.target.files || e.dataTransfer.files);
    },
    addFiles(newFiles: any) {
      if (this.multiple === true) {
        newFiles = [...newFiles, ...this.files];
      } else {
        newFiles = [...newFiles];
      }
      this.files = newFiles;

      this.refresh();
      this.dragover = false;
    },
    removeFiles(index: number) {
      this.files.splice(index, 1);
      this.refresh();
    },
    refresh() {
      this.empty = this.files.length == 0;
      this.$emit("input", this.multiple ? this.files : this.files[0]);
    },
  },
});
